<template>
  <v-card>
    <v-list-item
        dark
        class="primary"
    >
      <v-list-item-avatar>
        <v-icon>
          mdi-progress-check
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Progress Admin</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon @click.prevent="minimize = !minimize">
          <v-icon v-if="!minimize">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-row class="px-6 py-3" v-if="!minimize">
      <v-col
          col="6" md="4"
          v-for="(step, index) in progress"
          :key="'step_'+index"
      >
        <admin-step-card :step="step" :index="index" @change="changed=true"></admin-step-card>
      </v-col>
    </v-row>
    <v-card-actions v-if="!minimize">
      <div class="flex-grow-1"></div>
      <v-btn
          text
          color="primary"
          @click.stop="save()"
          :disabled="!changed"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AdminStepCard from './AdminStepCard'
// import difference from '../../../helpers/difference'
import differenceWith from 'lodash.differencewith'
import isEqual from 'lodash.isequal'
import {errorNotification} from "@/components/utils";


export default {
  components: {
    AdminStepCard
  },
  name: 'ApplicationProgressAdmin',
  props: {
    id: Number,
    progress: Array,
    step: Number
  },
  data() {
    return {
      minimize: false,
      changed: false,
      oldProgress: [],
    }
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name
    }
  },
  methods: {
    save() {
      const progress = JSON.parse(JSON.stringify(this.progress))
      const oldProgress = this.oldProgress
      const diff = differenceWith(progress, oldProgress, isEqual)
      // Multi steps
      let currentStep = 0
      for (let i in this.progress) {
        if ((this.progress[i].complete && !this.progress[i].error) || (!this.progress[i].complete && this.progress[i].error)) {
          currentStep = parseInt(i) + 1
        } else {
          continue
        }
      }
      this.$axios.patch('/applications/' + this.id + '/', {
        progress: JSON.stringify(this.progress),
        current_step: currentStep
      })
          .then(() => {
            this.$axios.post('/applications/' + this.id + '/progress/', {
              progress: diff
            })
                .catch((error) => {
                  errorNotification(error)
                })
          })
          .catch((e) => {
            this.$store.dispatch('snackbar/error', e.response.status + ' ' + e.response.statusText)
          })
    }
  },
  mounted() {
    this.oldProgress = JSON.parse(JSON.stringify(this.progress))
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.v-stepper {
  &__header {
    height: auto !important;
  }

  &__step {
    /*
    &.xs {
      flex: 1 0 100%;
    }
    &.sm {
      flex: 1 0 50%;
    }
    */
    &.md {
      flex: 1 0 33%;
    }

    &.lg {
      flex: 1 0 21%;
    }

    &.xl {
      flex: 1 0 24%;
    }
  }
}
</style>